module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selfFillingMachine"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("自助开单")]), _vm._v(" "), _c('group', {
    staticClass: "vux-1px-b"
  }, [_c('popup-radio', {
    attrs: {
      "title": "院区",
      "options": _vm.hispitalOption,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.hispital),
      callback: function($$v) {
        _vm.hispital = $$v
      },
      expression: "hispital"
    }
  })], 1), _vm._v(" "), _c('V-tabsilde', {
    staticClass: "vux-1px-t",
    attrs: {
      "tabList": _vm.tabList,
      "tabIndex": _vm.tabIndex,
      "contentH": _vm.contentH
    },
    on: {
      "tabClick": _vm.tabClick,
      "windResize": _vm.windResize
    }
  }, [_c('div', {
    staticClass: "ZDYswipercontent scroll",
    staticStyle: {
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('checklist', {
    attrs: {
      "label-position": "left",
      "options": _vm.inlineDescList
    },
    on: {
      "on-change": _vm.projectchange
    },
    model: {
      value: (_vm.inlineDescListValue),
      callback: function($$v) {
        _vm.inlineDescListValue = $$v
      },
      expression: "inlineDescListValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ZDYswipercontent scroll",
    staticStyle: {
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "ZDYswipercontent scroll",
    staticStyle: {
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "ZDYswipercontent scroll",
    staticStyle: {
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "ZDYswipercontent scroll",
    staticStyle: {
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "ZDYswipercontent scroll",
    staticStyle: {
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('div', {
    staticClass: "footerProject vux-1px-t"
  }, [_c('p', {
    staticClass: "chooseProject"
  }, [_vm._v("已勾选"), _c('span', {
    staticStyle: {
      "color": "#4ba7e8",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.inlineDescListValue.length) + " ")]), _vm._v("项检查项目")]), _vm._v(" "), _c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.submilt($event)
      }
    }
  }, [_vm._v("确 认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0057786d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/selfHelpFilingProject/selfFillingMachine.vue
// module id = viaW
// module chunks = 6